import {useState,useRef} from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
const Flexible = dynamic(
    import ('./../../js/flexible').then((mod)=>mod.flexible),{ssr:false}
)

const UserCenter = ({data}) => {
    const [personalInfo, setPersonalInfo] = useState({});
    const [refreshTag, setRefreshTag] = useState('');
    return (
    	<div>
            <Head>
                <title>99期货-用户协议</title>
                <link rel="shortcut icon" href="/img/favicon.ico" type="image/x-icon" />
                <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no" />
                <script src="noSupport.js"></script>
            </Head>
            <Flexible />
            <style>
                {`
                    .article{
                        width:90%;
                        margin:0 auto;
                        padding:30px 0;
                        font-size:16px;
                        line-height:30px;
                    }
                    .article h3{
                        font-weight:bold;
                        font-size:18px;
                        line-height:40px;
                    }
                    .article .ft{
                        font-weight:bold;
                    }
                `}
            </style>
            <div className="article">
                <h3>1、导言</h3>
                <p>欢迎您使用【99期货】。【99期货】是由99期货开发的提供24H全球财经资讯、行情数据等服务的一款APP软件。</p>
                <p>《99期货用户协议》（以下简称“本协议”）是指您与99期货（以下简称“公司”）之间就您注册、登录、使用（以下统称“使用”）【99期货】软件及相关服务所订立的协议。</p>
                <p>为了更好地为您提供服务，请您在开始使用【99期货】软件及相关服务之前，认真阅读并充分理解本协议。</p>
                <p>如您不同意本协议，这将导致我们无法为您提供完整的产品和服务，您也可以选择停止使用。</p>
                <p className="ft">如您自主选择同意或使用【99期货】软件及相关服务，则视为您已充分理解本协议，并同意作为本协议的一方当事人接受本协议以及其他与【99期货】软件及相关服务相关的协议和规则（包括但不限于《隐私政策》）的约束。</p>
                <h3>2、 【99期货】软件及相关服务</h3>
                <p>2.1 您使用【99期货】软件及相关服务，可以通过预装、公司已授权的第三方下载等方式获取【99期货】客户端应用程序或访问99期货（www.168cjw.com）相关网站。<b className="ft">若您并非从公司或经公司授权的第三方获取本软件的，公司无法保证非官方版本的【99期货】软件能够正常使用，您因此遭受的损失与公司无关。</b></p>
                <p>2.2 公司可能为不同的终端设备开发不同的应用程序软件版本，您应当根据实际设备状况获取、下载、安装合适的版本。如您不再使用【99期货】软件及相关服务，您也可自行卸载相应的应用程序软件。</p>
                <p>2.3 为更好的提升用户体验及服务，公司将不定期提供【99期货】软件及相关服务的更新或改变（包括但不限于软件修改、升级、功能强化、开发新服务、软件替换等），您可根据需要自行选择是否更新相应的版本。</p>
                <p>为保证【99期货】软件及相关服务安全、提升用户服务，在【99期货】软件及相关服务的部分或全部更新后，公司将在可行的情况下以妥当的方式（包括但不限于系统提示、公告、站内信等）提示您，您有权选择接受更新后的版本；如您选择不作更新，【99期货】软件及相关服务的部分功能将受到限制或不能正常使用。</p>
                <p>2.4 除非得到公司事先书面授权，您不得以任何形式对【99期货】软件及相关服务进行包括但不限于改编、复制、传播、垂直搜索、镜像或交易等未经授权的访问或使用。</p>
                <p>2.5 您理解，使用【99期货】软件及相关服务需自行准备与软件及相关服务有关的终端设备（如电脑、手机等），一旦您在终端设备中打开【99期货】软件或访问99期货报社的网站，即视为您使用【99期货】软件及相关服务。为充分实现【99期货】的全部功能，您可能需要将终端设备联网，您理解由您承担所需要的费用（如流量费、上网费等）。</p>
                <p>2.6 公司许可您一项个人的、不可转让的、非独占地和非商业的合法使用【99期货】软件及相关服务的权利。本协议未明示授权的其他一切权利仍由公司保留，您在行使该些权利前须另行获得公司的书面许可，同时公司如未行使前述任何权利，并不构成对该权利的放弃。</p>
                <p>2.7 您无需注册也可开始使用【99期货】软件及相关服务，但部分功能或服务可能会受到影响。同时，您也理解，为使您更好地使用【99期货】软件及相关服务，保障您的账号安全，某些功能和/或某些单项服务项目将要求您按照相关司法区域的规定，提供真实的身份信息实名注册并登录后方可使用。</p>
                <h3>3、关于“账号”</h3>
                <p>3.1 【99期货】软件及相关服务为您提供了注册通道，您有权选择合法的字符组合作为自己的账号，并自行设置符合安全要求的密码。用户设置的账号、密码是用户用以登录并使用【99期货】软件及相关服务的凭证。</p>
                <p className="ft">3.2 您理解并承诺，您所设置的账号不得违反国家法律法规及公司的相关规则，不得实施任何侵害国家利益、损害其他公民合法权益，有害社会道德风尚的行为，您的账号名称、头像和简介等注册信息及其他个人信息中不得出现违法和不良信息，未经他人许可不得用他人名义（包括但不限于冒用他人姓名、名称、字号、头像等足以让人引起混淆的方式）开设账号，不得恶意注册【99期货】账号（包括但不限于频繁注册、批量注册账号等行为）。公司有权对您提交的信息进行审核。</p>
                <p className="ft">3.3 您的账号仅限于您本人使用，未经公司书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。如果公司发现或者有合理理由认为使用者并非账号初始注册人，为保障账号安全，公司有权立即暂停或终止向该注册账号提供服务，或注销该账号。</p>
                <p>3.4 您有责任维护个人账号、密码的安全性与保密性，并对您以注册账号名义所从事的活动承担全部法律责任，包括但不限于您在【99期货】软件及相关服务上进行的任何数据修改、言论发表、款项支付等操作行为可能引起的一切法律责任。您应高度重视对账号与密码的保密，在任何情况下不向他人透露账号及密码。若发现他人未经许可使用您的账号或发生其他任何安全漏洞问题时，您应当立即通知公司。</p>
                <p>3.5 在丢失账号或遗忘密码时，您可遵照公司的申诉途径及时申诉请求找回账号或密码。您理解并认可，公司的密码找回机制仅需要识别申诉单上所填资料与系统记录资料具有一致性，而无法识别申诉人是否系真正账号有权使用者。公司特别提醒您应妥善保管您的账号和密码。当您使用完毕后，应安全退出。如因您保管不当等自身原因或其他不可抗因素导致遭受盗号或密码丢失，您将自行承担相应责任。</p>
                <p className="ft">3.6 在注册、使用和管理账号时，您应保证注册账号时填写的身份信息的真实性，请您在注册、管理账号时使用真实、准确、合法、有效的相关身份证明材料及必要信息（包括您的姓名及电子邮件地址、联系电话、联系地址等）。若您提交的材料或提供的信息不规范或不符合要求的，则公司有权拒绝为您提供相关功能，您可能无法使用【99期货】软件及相关服务或在使用过程中部分功能受到限制。</p>
                <p>3.7 除自行注册【99期货】账号外，用户也可授权使用其合法拥有的包括但不限于公司和/或其关联公司其他软件用户账号，以及实名注册的第三方软件用户账号登录使用【99期货】软件及相关服务，但第三方软件或平台对此有限制或禁止的除外。当用户以前述已有账号登录使用的，应保证相应账号已进行实名注册登记，并同样适用本协议中的相关条款。</p>
                <p>3.8 当您完成【99期货】的账号注册、登录并进行合理和必要的身份验证后，您可随时浏览、修改自己提交的个人身份信息。您理解并同意，出于安全性和身份识别（如账号或密码找回申诉服务等）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。您也可以申请注销账号，公司会在完成个人身份、安全状态、设备信息等合理和必要的验证后协助您注销账号，并依照您的要求删除有关您账号的一切信息，法律法规另有规定的除外。</p>
                <p>3.9 您理解并同意，为了充分使用账号资源，如您在注册后未及时进行初次登录使用或连续超过六个月未登录账号使用等情形，公司有权收回您的账号。</p>
                <h3>4、用户个人信息保护</h3>
                <p>公司与您一同致力于您个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，保护用户个人信息是公司的基本原则之一。在使用【99期货】软件及相关服务的过程中，您可能需要提供您的个人信息（包括但不限于姓名、电话号码、位置信息等），以便公司向您提供更好的服务和相应的技术支持。公司将运用加密技术、匿名化处理等其他与【99期货】软件及相关服务相匹配的技术措施及其他安全措施保护您的个人信息，更多关于用户个人信息保护的内容，请参见《隐私政策》。</p>
                <h3>5、 用户行为规范</h3>
                <p>5.1 用户行为要求</p>
                <p>您应当对您使用本软件及相关服务的行为负责，除非法律允许或者经公司事先书面许可，您使用【99期货】软件及相关服务不得具有下列行为：</p>
                <p className="ft">5.1.1 使用未经公司授权或许可的任何插件、外挂、系统或第三方工具对【99期货】软件及相关服务的正常运行进行干扰、破坏、修改或施加其他影响。</p>
                <p className="ft">5.1.2 利用或针对【99期货】软件及相关服务进行任何危害计算机网络安全的行为，包括但不限于：</p>
                <p>（1）非法侵入他人网络、干扰他人网络正常功能、窃取网络数据等危害网络安全的活动；</p>
                <p>（2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；</p>
                <p>（3）明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助；</p>
                <p>（4）使用未经许可的数据或进入未经许可的服务器/账号；</p>
                <p>（5）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；</p>
                <p>（6）未经许可，企图探查、扫描、测试【99期货】系统或网络的弱点或其它实施破坏网络安全的行为；</p>
                <p>（7）企图干涉、破坏【99期货】系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；</p>
                <p>（8）伪造TCP/IP数据包名称或部分名称；</p>
                <p>（9） 对【99期货】软件及相关服务进行反向工程、反向汇编、编译或者以其他方式尝试发现本软件的源代码；</p>
                <p>（10） 恶意注册【99期货】软件及相关服务的账号，包括但不限于频繁、批量注册账号；</p>
                <p>（11） 违反法律法规、本协议、公司的相关规则及侵犯他人合法权益的其他行为。</p>
                <p>5.1.3 如果公司有理由认为您的行为违反或可能违反上述约定的，公司可独立进行判断并处理，且有权在不事先通知的情况下终止向您提供服务，并追究相关法律责任。</p>
                <p>5.2 信息内容规范</p>
                <p>5.2.1 您按规定完成实名认证后，可以以注册账号登录【99期货】发布内容、跟帖评论等。</p>
                <p className="ft">5.2.2 您评论、发布、传播的内容应自觉遵守法律、法规、遵守公共秩序，尊重社会公德、国家利益、公民合法权益、道德风尚和信息真实性等要求。</p>
                <p>5.3 公司设立公众投诉、举报平台，您可按照公司公示的投诉举报制度向公司投诉、举报各类违法违规行为、违法传播活动、违法有害信息等内容，公司将及时受理和处理您的投诉举报。</p>
                <h3>6、【99期货】信息内容的使用规范</h3>
                <p>未经公司书面许可，您不得自行或授权、允许、协助任何第三人对本协议【99期货】软件及相关服务中信息内容进行如下行为：</p>
                <p>（1）复制、读取、采用【99期货】软件及相关服务的信息内容，用于包括但不限于宣传、增加阅读量、浏览量等商业用途；</p>
                <p>（2）擅自编辑、整理、编排【99期货】软件及相关服务的信息内容后在【99期货】软件及相关服务的源页面以外的渠道进行展示；</p>
                <p>（3）采用包括但不限于特殊标识、特殊代码等任何形式的识别方法，自行或协助第三人对【99期货】软件及相关服务的信息内容产生流量、阅读量引导、转移、劫持等不利影响；</p>
                <p>（4）其他非法获取或使用【99期货】软件及相关服务的信息内容的行为。</p>
                <h3>7、违约处理</h3>
                <p className="ft">7.1 针对您违反本协议或其他服务条款的行为，公司有权独立判断并视情况采取预先警示、拒绝发布、立即停止传输信息、删除跟帖、短期禁止发言、限制账号部分或者全部功能直至永久关闭账号等措施。公司有权公告处理结果，且有权根据实际情况决定是否恢复相关账号的使用。对涉嫌违反法律法规、涉嫌违法犯罪的行为将保存有关记录，并依法向有关主管部门报告、配合有关主管部门调查。</p>
                <p className="ft">7.2 因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行处理并承担全部可能由此引起的法律责任。因您的违法、侵权或违约等行为导致公司及其关联公司向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿公司及其关联公司因此遭受的全部损失。</p>
                <p className="ft">7.3 公司尊重并保护用户及他人的知识产权、名誉权、姓名权、隐私权等合法权益。您保证，在使用【99期货】软件及相关服务时上传的文字、图片、视频、音频、链接等不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。否则，公司有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。针对第三方提出的全部权利主张，您应自行处理并承担全部可能由此引起的法律责任；如因您的侵权行为导致公司及其关联公司遭受损失的（包括经济、商誉等损失），您还应足额赔偿公司及其关联公司遭受的全部损失。</p>
                <h3>8、服务的变更、中断和终止</h3>
                <p>8.1 您理解并同意，公司提供的【99期货】软件及相关服务是按照现有技术和条件所能达到的现状提供的。公司会尽最大努力向您提供服务，确保服务的连贯性和安全性。您理解，公司不能随时预见和防范技术以及其他风险，包括但不限于不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用本软件及服务以及其他的损失和风险。</p>
                <p>8.2 您理解并同意，公司为了服务整体运营、平台运营安全的需要，有权视具体情况有权决定服务/功能设置、范围，修改、中断、中止或终止【99期货】软件及相关服务。</p>
                <h3>9、广告</h3>
                <p>9.1 您理解并同意，在使用【99期货】软件及相关服务过程中公司可能会向您推送具有相关性的信息、广告发布或品牌推广服务，且公司将在【99期货】软件及相关服务中展示【99期货】软件及相关服务相关和/或第三方供应商、合作伙伴的商业广告、推广或信息（包括商业或非商业信息）。</p>
                <p>9.2 公司依照法律规定履行广告及推广相关义务，您应当自行判断该广告或推广信息的真实性和可靠性并为自己的判断行为负责。除法律法规明确规定外，您因该广告或推广信息进行的购买、交易或因前述内容遭受的损害或损失由您自行承担，公司不予承担责任。</p>
                <h3>10、知识产权</h3>
                <p>10.1 公司在【99期货】软件及相关服务中提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、音频、视频、图表、版面设计、电子文档等）的知识产权属于公司所有。公司提供本服务时所依托的软件的著作权、专利权及其他知识产权均归公司所有。未经公司许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载）【99期货】软件及相关服务中的内容。</p>
                <p className="ft">10.2 您理解并同意，在使用【99期货】软件及相关服务时发布上传的文字、图片、视频、音频等均由您原创或已获合法授权。您通过【99期货】上传、发布的任何内容的知识产权归属您或原始著作权人所有。</p>
                <p>10.3 公司为【99期货】开发、运营提供技术支持，并对【99期货】软件及相关服务的开发和运营等过程中产生的所有数据和信息等享有法律法规允许范围内的全部权利。</p>
                <p className="ft">10.4 请您在任何情况下都不要私自使用公司的包括但不限于“99期货”、“www.168cjw.com”等在内的任何商标、域名、网站名称等（以下统称为“标识”）。未经公司事先书面同意，您不得将本条款前述标识以单独或结合任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理该些标识的行为。由于您违反本协议使用公司上述商标、标识等给公司或他人造成损失的，由您承担全部法律责任。</p>
                <h3>11、免责声明</h3>
                <p className="ft">11.1 您理解并同意，【99期货】软件及相关服务可能会受多种因素的影响或干扰，公司不保证(包括但不限于)：</p>
                <p className="ft">11.1.1 【99期货】软件及相关服务完全适合用户的所有使用要求；</p>
                <p className="ft">11.1.2 【99期货】软件及相关服务不受干扰，及时、安全、可靠或不出现任何错误；您经由公司取得的任何软件、服务或其他材料符合用户的期望；</p>
                <p className="ft">11.1.3 【99期货】软件及相关服务中任何错误都将能得到更正。</p>
                <p className="ft">11.2 如有涉财产的网络信息、账户密码、广告或推广等信息，请您谨慎对待并自行进行判断，您因此遭受的利润、商业信誉、资料损失或其他有形或无形损失，公司不承担任何直接、间接、附带、特别、衍生性或惩罚性的赔偿责任。</p>
                <p className="ft">11.3 您理解并同意，在使用【99期货】软件及相关服务过程中，可能遇到不可抗力等因素（不可抗力是指不能预见、不能克服并不能避免的客观事件），包括但不限于自然灾害(如洪水、地震、台风等)、政府行为、战争、罢工、骚动、暴乱等。出现不可抗力情况时，公司将努力在第一时间及时修复，但因不可抗力造成的损失，公司在法律法规范围内免于承担责任。</p>
                <p className="ft">11.4 公司依据本协议约定获得处理违法违规内容的权利，该权利不构成公司的义务或承诺，公司不能保证及时发现违法行为或进行相应处理。</p>
                <p className="ft">11.5 您理解并同意，关于【99期货】软件及相关服务，公司不提供任何种类的明示或暗示担保或条件，包括但不限于商业适售性、特定用途适用性等。您对【99期货】软件及相关服务的使用行为需自行承担相应风险。</p>
                <p className="ft">11.6 您理解并同意，本协议是在保障遵守相关法律法规、维护公序良俗，保护他人合法权益，公司在能力范围内尽最大的努力按照相关法律法规进行判断，但并不保证公司判断完全与司法机关、行政机关的判断一致，如因此产生的后果您已经理解并同意自行承担。</p>
                <p className="ft">11.7 在任何情况下，公司均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用【99期货】软件及相关服务而遭受的利润损失，承担责任。</p>
                <h3>12、其他</h3>
                <p className="ft">12.1 本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国香港特别行政区法律法规。若本协议之任何规定因与中华人民共和国香港特别行政区的法律抵触而无效或不可执行，则这些条款将尽可能按照接近本协议原条文意旨重新解析，且本协议其它规定仍应具有完整的效力及效果。</p>
                <p className="ft">12.2 本协议的签订地为中华人民共和国香港特别行政区。若您因本协议与公司发生任何争议，双方应尽量友好协商解决；如协商不成的，您同意应将相关争议提交至本协议签订地的法院诉讼解决。</p>
                <p className="ft">12.3 为给您提供更好的服务或法律法规、政策进行调整，【99期货】及相关服务将不时更新与变化，我们会适时对本协议进行修订，这些修订构成本协议的一部分。如您继续使用【99期货】软件及相关服务，表示同意接受修订后的本协议的内容。
    如您对修改后的协议条款存有异议的，请立即停止登录或使用【99期货】软件及相关服务。若您继续登录或使用【99期货】软件及相关服务，即视为您认可并接受修改后的协议条款。</p>
            </div>
        </div>
    );
};

export async function getStaticProps(context){


    return {
        props:{
            
        },
    }
}




export default UserCenter;